/**
 * Window home settings extraction - extracted to break circular dependency
 * between mergeSettingsSet.ts and getMergedWindowSettings.ts
 */
import type { HomeSettings } from "building-types/settings/homeSettings";
import type { WindowHomeSettings } from "building-types/windows/windowMergeTypes";

export function getWindowHomeSettings(homeSettings: HomeSettings): WindowHomeSettings {
  return {
    window: homeSettings.window,
    awning: homeSettings.awning,
    windowFraming: homeSettings.windowFraming,
    windowWrapping: homeSettings.windowWrapping,
    windowMaterial: homeSettings.windowMaterial,
    windowShutters: homeSettings.windowShutters,
    windowMullions: homeSettings.windowMullions,
    exteriorWindowCasing: homeSettings.exteriorWindowCasing,
    interiorWindowCasing: homeSettings.interiorWindowCasing,
  };
}
